import { createVNode as _createVNode, resolveComponent as _resolveComponent, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, withCtx as _withCtx, vModelText as _vModelText, vModelSelect as _vModelSelect } from "vue"

const _hoisted_1 = /*#__PURE__*/_createVNode("div", { class: "col-xxl-12 mb-5" }, null, -1)
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "col-xxl-12 mb-5" }, null, -1)
const _hoisted_3 = { class: "col-xxl-12" }
const _hoisted_4 = {
  key: 0,
  class: "card-header border-0 pt-5"
}
const _hoisted_5 = {
  key: 1,
  class: "col-md-3 border border-gray-300 border-dashed rounded min-w-275px py-3 px-4 mx-6 mb-3",
  align: "center"
}
const _hoisted_6 = { align: "center" }
const _hoisted_7 = /*#__PURE__*/_createVNode("span", { class: "svg-icon svg-icon-success me-2" }, null, -1)
const _hoisted_8 = {
  class: "fs-2 fw-bolder",
  "data-kt-countup": "true",
  "data-kt-countup-value": "4500",
  "data-kt-countup-prefix": "$"
}
const _hoisted_9 = /*#__PURE__*/_createVNode("div", { class: "fw-bold fs-6 text-gray-400" }, "  PMA Wins Raffle Tickets", -1)
const _hoisted_10 = { class: "card-body py-3" }
const _hoisted_11 = /*#__PURE__*/_createVNode("h3", { class: "card-title align-items-start flex-column mb-5" }, [
  /*#__PURE__*/_createVNode("span", { class: "card-label fw-bolder fs-3 mb-1" }, "Your Inventory")
], -1)
const _hoisted_12 = { class: "table-responsive" }
const _hoisted_13 = { class: "table align-middle gs-0 gy-4" }
const _hoisted_14 = /*#__PURE__*/_createVNode("thead", null, [
  /*#__PURE__*/_createVNode("tr", { class: "fw-bolder text-muted bg-light" }, [
    /*#__PURE__*/_createVNode("th", { class: "ps-4 min-w-225px rounded-start" }, "Product"),
    /*#__PURE__*/_createVNode("th", { class: "min-w-50px" }, "Remaining"),
    /*#__PURE__*/_createVNode("th", { class: "min-w-50px" }, "Quantity"),
    /*#__PURE__*/_createVNode("th", { class: "min-w-100px" }, "Position"),
    /*#__PURE__*/_createVNode("th", { class: "min-w-90px" }, "User ID"),
    /*#__PURE__*/_createVNode("th", { class: "min-w-125px" }, "Action")
  ])
], -1)
const _hoisted_15 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_16 = /*#__PURE__*/_createTextVNode("   This product is ")
const _hoisted_17 = /*#__PURE__*/_createVNode("u", null, "NOT", -1)
const _hoisted_18 = /*#__PURE__*/_createTextVNode(" PMA of the month.")
const _hoisted_19 = /*#__PURE__*/_createVNode("option", { value: "L" }, "Left", -1)
const _hoisted_20 = /*#__PURE__*/_createVNode("option", { value: "R" }, "Right", -1)
const _hoisted_21 = { key: 0 }
const _hoisted_22 = {
  key: 2,
  href: "javascript:void(0);",
  class: "btn btn-success btn-sm dashboardFontStyle mb-2"
}
const _hoisted_23 = /*#__PURE__*/_createTextVNode("    ")
const _hoisted_24 = {
  key: 4,
  href: "javascript:void(0);",
  class: "btn btn-warning btn-sm dashboardFontStyle mb-2"
}
const _hoisted_25 = {
  key: 6,
  href: "javascript:void(0);",
  class: "btn btn-primary btn-sm dashboardFontStyle mb-2"
}
const _hoisted_26 = /*#__PURE__*/_createTextVNode("    ")
const _hoisted_27 = { class: "svg-icon svg-icon-1" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_skeleton = _resolveComponent("el-skeleton")
  const _component_EstoreTabNavigator = _resolveComponent("EstoreTabNavigator")
  const _component_font = _resolveComponent("font")
  const _component_inline_svg = _resolveComponent("inline-svg")
  const _component_EstoreExpiry = _resolveComponent("EstoreExpiry")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _hoisted_1,
    _withDirectives(_createVNode("div", null, [
      _createVNode(_component_el_skeleton, {
        rows: 10,
        animated: ""
      })
    ], 512), [
      [_vShow, _ctx.loading]
    ]),
    _hoisted_2,
    _withDirectives(_createVNode("div", _hoisted_3, [
      _createVNode("div", {
        class: [_ctx.widgetClasses, "card"]
      }, [
        (!_ctx.isOverriden)
          ? (_openBlock(), _createBlock("div", _hoisted_4, [
              _createVNode(_component_EstoreTabNavigator, { "widget-classes": "card-xxl-stretch mb-5 mb-xxl-8" })
            ]))
          : _createCommentVNode("", true),
        (_ctx.pmawinsraffleticketcount != 0)
          ? (_openBlock(), _createBlock("div", _hoisted_5, [
              _createVNode("div", _hoisted_6, [
                _hoisted_7,
                _createVNode("div", _hoisted_8, _toDisplayString(_ctx.numberWithCommas(Number(_ctx.pmawinsraffleticketcount)).replace(".00", "")), 1)
              ]),
              _hoisted_9
            ]))
          : _createCommentVNode("", true),
        _createVNode("div", _hoisted_10, [
          _hoisted_11,
          _createVNode("div", _hoisted_12, [
            _createVNode("table", _hoisted_13, [
              _hoisted_14,
              _createVNode("tbody", null, [
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.list, (item, index) => {
                  return (_openBlock(), _createBlock("tr", { key: index }, [
                    _createVNode("td", null, [
                      _createTextVNode("   " + _toDisplayString(item.product) + " ", 1),
                      _hoisted_15,
                      (item.isPMAOfTheMonth != 1)
                        ? (_openBlock(), _createBlock(_component_font, {
                            key: 0,
                            style: {"font-size":"10px !important","color":"red !important"}
                          }, {
                            default: _withCtx(() => [
                              _hoisted_16,
                              _hoisted_17,
                              _hoisted_18
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true)
                    ]),
                    _createVNode("td", null, _toDisplayString(Math.round(item.quantity)), 1),
                    _createVNode("td", null, [
                      _withDirectives(_createVNode("input", {
                        class: "form-control dashboardFontStyle",
                        type: "text",
                        id: 'store_count_'+item.prodcode,
                        name: "",
                        style: {"width":"50px"},
                        "onUpdate:modelValue": ($event: any) => (_ctx.store_count[index] = $event)
                      }, null, 8, ["id", "onUpdate:modelValue"]), [
                        [_vModelText, _ctx.store_count[index]]
                      ])
                    ]),
                    _createVNode("td", null, [
                      _withDirectives(_createVNode("select", {
                        class: "form-select form-select-solid",
                        id: 'pos_' + item.prodcode,
                        style: {"width":"50%"},
                        "onUpdate:modelValue": ($event: any) => (_ctx.pos[index] = $event)
                      }, [
                        _hoisted_19,
                        _hoisted_20
                      ], 8, ["id", "onUpdate:modelValue"]), [
                        [_vModelSelect, _ctx.pos[index]]
                      ])
                    ]),
                    _createVNode("td", null, [
                      _withDirectives(_createVNode("input", {
                        class: "form-control",
                        type: "text",
                        id: 'tousid_' + item.prodcode,
                        style: {"width":"100px"},
                        "onUpdate:modelValue": ($event: any) => (_ctx.tousid[index] = $event)
                      }, null, 8, ["id", "onUpdate:modelValue"]), [
                        [_vModelText, _ctx.tousid[index]]
                      ]),
                      _createVNode("input", {
                        type: "hidden",
                        id: 'prodcode_' + item.prodcode
                      }, null, 8, ["id"])
                    ]),
                    _createVNode("td", null, [
                      (!_ctx.isOverriden)
                        ? (_openBlock(), _createBlock("div", _hoisted_21, [
                            (_ctx.isprocessing[index] === '0' && item.isPMAWins_Additional == 0)
                              ? (_openBlock(), _createBlock("a", {
                                  key: 0,
                                  href: "javascript:void(0);",
                                  onClick: ($event: any) => {_ctx.send_instore(item.prodcode, index, 0);},
                                  class: "btn btn-success btn-sm dashboardFontStyle mb-2"
                                }, "Send (PMA)", 8, ["onClick"]))
                              : _createCommentVNode("", true),
                            (_ctx.isprocessing[index] === '0' && item.isPMAWins_Additional == 1)
                              ? (_openBlock(), _createBlock("a", {
                                  key: 1,
                                  href: "javascript:void(0);",
                                  onClick: ($event: any) => {_ctx.send_instore(item.prodcode, index, 0);},
                                  class: "btn btn-info btn-sm dashboardFontStyle mb-2"
                                }, "Use (Raffle)", 8, ["onClick"]))
                              : _createCommentVNode("", true),
                            (_ctx.isprocessing[index] === '1')
                              ? (_openBlock(), _createBlock("a", _hoisted_22, "Processing..."))
                              : _createCommentVNode("", true),
                            _hoisted_23,
                            (_ctx.isprocessing[index] === '0' && item.isEasyVerseUpgrade_Product == 1)
                              ? (_openBlock(), _createBlock("a", {
                                  key: 3,
                                  href: "javascript:void(0);",
                                  onClick: ($event: any) => {_ctx.send_instore(item.prodcode, index, 1);},
                                  class: "btn btn-warning btn-sm dashboardFontStyle mb-2"
                                }, "Upgrade", 8, ["onClick"]))
                              : _createCommentVNode("", true),
                            (_ctx.isprocessing[index] === '1' && item.isEasyVerseUpgrade_Product == 1)
                              ? (_openBlock(), _createBlock("a", _hoisted_24, "Processing..."))
                              : _createCommentVNode("", true),
                            (_ctx.isprocessing[index] === '0' && 
                        (
                          //item.prodcode == 'C247U18' || item.prodcode == 'CPLU18' || item.prodcode == 'C2EU18' || item.prodcode == 'CPEU18' ||
                          //item.prodcode == 'CU18B10' || item.prodcode == 'CU18B25' || item.prodcode == 'CU18B100' || item.prodcode == 'CU18B150' || item.prodcode == 'CPU18B12' || item.prodcode == 'CPU18B48' || item.prodcode == 'CPU18B60'
                          item.isUSTrip_Product == 1
                        ) && 
                          _ctx.isShowUSTrip === 'true')
                              ? (_openBlock(), _createBlock("a", {
                                  key: 5,
                                  href: "javascript:void(0);",
                                  onClick: ($event: any) => {_ctx.send_instore(item.prodcode, index, 2);},
                                  class: "btn btn-primary btn-sm dashboardFontStyle mb-2"
                                }, "US Trip", 8, ["onClick"]))
                              : _createCommentVNode("", true),
                            (_ctx.isprocessing[index] === '1' && 
                        (
                          //item.prodcode == 'C247U18' || item.prodcode == 'CPLU18' || item.prodcode == 'C2EU18' || item.prodcode == 'CPEU18' ||
                          //item.prodcode == 'CU18B10' || item.prodcode == 'CU18B25' || item.prodcode == 'CU18B100' || item.prodcode == 'CU18B150' || item.prodcode == 'CPU18B12' || item.prodcode == 'CPU18B48' || item.prodcode == 'CPU18B60'
                          item.isUSTrip_Product == 1  
                        ) && 
                          _ctx.isShowUSTrip === 'true')
                              ? (_openBlock(), _createBlock("a", _hoisted_25, "Processing..."))
                              : _createCommentVNode("", true),
                            _hoisted_26,
                            _createVNode("button", {
                              type: "button",
                              class: "btn px-2 py-2",
                              "data-bs-toggle": "modal",
                              "data-bs-target": `#kt_modal_estore_expiry`,
                              onClick: ($event: any) => {_ctx.viewExpiryDate(item.prodcode,item.product);}
                            }, [
                              _createVNode("span", _hoisted_27, [
                                _createVNode(_component_inline_svg, { src: "media/icons/duotone/Communication/More.svg" })
                              ])
                            ], 8, ["onClick"]),
                            _createVNode(_component_EstoreExpiry, {
                              "widget-classes": "card-xxl-stretch mb-5 mb-xxl-8",
                              pname: _ctx.modal_prodname,
                              list2: _ctx.expiry_list
                            }, null, 8, ["pname", "list2"])
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ]))
                }), 128))
              ])
            ])
          ])
        ])
      ], 2)
    ], 512), [
      [_vShow, !_ctx.loading]
    ])
  ], 64))
}